(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for birthday calendar picker 
    module.directive('agendaAppointmentBirthday', ['$timeout', '$document', 'UserSearchService', 'HelperService', 'UserService', AgendaAppointmentBirthdayDirectiveFn]);
    function AgendaAppointmentBirthdayDirectiveFn($timeout, $document, UserSearchService, HelperService, UserService) {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-birthday.template.html',
            scope: {
                date: '=',
                user: '=',
                focus: '@?'
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            // picker
            var picker = element.children().eq(0).data('DateTimePicker');

            // input for focus
            var input = element.find("input");

            // dropdown list for users
            var dropdown = element.find('ul');
            
            // outside watcher
            var outsideWatcher = null;

            activate();

            // if date changes
            scope.changed = function () {
                var value = input.val();
                if (value === null || value.length <= 0) { return; }

                scope.date = moment(value, HelperService.getLocalDateFormat()).format();
                // search
                searchByBirthday();
            };

            // key down event 
            function keyDown(event) {
                var active = dropdown.find('li.active');
                // switch the key-type
                if (event.which === 40) {           // key down
                    // is some li-element active ?
                    var next = null;
                    if (active === undefined) {
                        active = dropdown.find('li:first');
                        next = active;
                    }
                    else {
                        next = active.next();
                        if (next[0] === undefined) {
                            next = dropdown.find('li:first');
                        }
                    }

                    active.removeClass("active");
                    next.addClass("active");
                }
                else if (event.which === 38) {          // key up
                    // is some li-element active ?
                    var prev = null;
                    if (active === undefined) {
                        active = dropdown.find('li:last');
                        prev = active;
                    }
                    else {
                        prev = active.prev();
                        if (prev[0] === undefined) {
                            prev = dropdown.find('li:last');
                        }
                    }

                    active.removeClass("active");
                    prev.addClass("active");
                }
                else if (event.which === 13) {          // enter
                    if (active !== undefined) { active.trigger("click"); }
                }
                else {
                    dropdown.hide();
                }
                return true;
            } // keyDown

            // click event -> outside click
            function outsideClick(event) {
                // hide dropdown if clicked outside
                dropdown.hide();
                return true;
            } // outsideClick

            // activate
            function activate() {
                input[0].placeholder = HelperService.getLocalDateFormat();

                // date to interact with picker
                scope.interact = scope.date;
                // options of picker
                scope.options = {
                    format: HelperService.getLocalDateFormat(),
                    showClear: true,
                    viewMode: 'years',
                    allowInputToggle: true,                    
                    useCurrent: false
                };

                // key-up
                input.on("keyup", function (event) {
                    var value = input.val();

                    // Validate if Number -> Length == 6
                    // Or NaN -> Length == 10
                    if (value) {
                        if ((isNaN(value) && value.length === 10) || (!isNaN(value) && value.length === 8)) {
                            // Validate And Search
                            validateAndSearch(value);
                        } // if                        
                    } // if
                });

                // listen on enter/tab
                input.on("keydown", function (event) {

                    // on enter and tab
                    if (event.which === 13 || event.which === 9) {
                        // event.preventDefault();
                        // event.stopPropagation();
                        // save input value
                        var value = input.val();
                        if (value === null || value.length <= 0) { return; }

                        // Validate And Search
                        validateAndSearch(value);

                        return event;
                    } // if

                    return event;
                });

                // validate date and search by date
                function validateAndSearch(value) {
                    var momDate = moment(value, HelperService.getLocalDateFormat());
                    if (!momDate.isValid()) {
                        scope.interact = null;
                        return;
                    }
                    
                    // formatted date
                    scope.date = momDate.format();

                    // search
                    searchByBirthday();

                    scope.$applyAsync(function () {
                        // remove focus from input
                        input.blur();
                    });
                }

                // keyDown Event
                $document.on("keydown", keyDown);

                // listen on outside click
                $document.on('click', outsideClick);

                // listen on outside date change coming from an external patient
                outsideWatcher = scope.$watch(function () {
                    return scope.date;
                }, function (newVal, oldVal) {
                    if (!newVal) {
                        scope.interact = null;
                        return;
                    }

                    // format to object
                    var newDate = moment(newVal);
                    if (newDate && newDate.isValid()) {
                        scope.interact = newDate;
                    }
                });

                setTimeout(function() {
                    if (scope.focus === 'true') {
                        element.find('input')[0].focus();
                    }
                }, 0);
            } // activate


            // search by birthday
            function searchByBirthday() {
                picker.hide();
                if (typeof scope.date === 'undefined' || scope.date === null) { return; }

                // searching
                UserSearchService.searchByBirthday(HelperService.backendDate(scope.date)).then(function (result) {

                    scope.users = HelperService.prepareUserSearchResult(result, true);
                    
                    // show list
                    if (result && result.length > 0) {
                        dropdown.show();
                        dropdown.find('li').removeClass("active");
                        dropdown.find('li:first').addClass("active");
                    } // if
                    else {
                        dropdown.hide();
                    } // else
                });
            } // searchByBirthday

            // select user from result list
            scope.select = function (user, event) {
                scope.user = user;
                event.preventDefault();
                event.stopPropagation();
                dropdown.hide();
             
                if (scope.user && scope.user.detail) {
                    // show warnings of patients after it has been selected
                    UserService.showSpecificPatientWarning(scope.user.caption, scope.user.detail.warningInfo);
                }
            };


            // destroy
            scope.$on('$destroy', function () {
                picker.destroy();
                input.off("keydown");
                input.off("keyup");
                input = null;
                picker = null;
                outsideWatcher();
                outsideWatcher = null;

                $document.off("keydown", keyDown);
                $document.off("click", outsideClick);
            });

        }
    }

})();